import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { AppConfig } from "../../common/constants";
import logo from "../../YB1type_Blk.png";
import "../main.css";

export interface IProps extends WithTranslation {
  /**
   * css名
   */
  className?: string;
}

class Footer extends React.Component<IProps> {
  private readonly TermsEnabled = AppConfig.LINK_TERMS_ENABLED;
  private readonly IncidentsEnabled = AppConfig.LINK_INCIDENTS_ENABLED;

  constructor(props: IProps) {
    super(props);

    this.handleOpenURL = this.handleOpenURL.bind(this);
  }

  handleOpenURL(url: string) {
    window.open(url);
  }

  render() {
    const { className, t } = this.props;
    const terms = this.TermsEnabled ? (
      <a href="#" onClick={() => this.handleOpenURL(t("link_url_terms"))}>
        {t("footer_terms")}
      </a>
    ) : (
      ""
    );
    const incidents = this.IncidentsEnabled ? (
      <a href="#" onClick={() => this.handleOpenURL(t("link_url_incidents"))}>
        {t("footer_incidents")}
      </a>
    ) : (
      ""
    );

    return (
      <footer className={className}>
        <img src={logo} className="logo" alt="logo" />
        <ul>
          <li>{terms}</li>
          <li>{incidents}</li>
        </ul>
        <div className="copyright">{t("footer_copyright")}</div>
      </footer>
    );
  }
}

export default withTranslation()(Footer);
